import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { initialOperation, isUserInfo } from "./data/userInfo";
import { CircularProgress } from "@mui/material";
import { useAccessLog } from "./accessLog/useAccessLog";

const ProtectedRoute = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // アクセスログを自動送信
    useAccessLog();

    useEffect(() => {
        const checkAuthStatus = async () => {
            try {
                if (isUserInfo()) {
                    // 既にユーザー情報があれば認証済み
                    console.log("ProtectedRoute: 既存のユーザー情報を確認しました");
                    setIsAuthenticated(true);
                } else {
                    console.log("ProtectedRoute: ユーザー情報を取得中...");
                    await initialOperation(); // ユーザー情報取得処理
                    if (isUserInfo()) {
                        console.log("ProtectedRoute: ユーザー情報取得成功");
                        setIsAuthenticated(true);
                    } else {
                        console.log("ProtectedRoute: ユーザー情報取得失敗");
                        setIsAuthenticated(false); // 取得できなければ非認証
                    }
                }
            } catch (error) {
                console.error("ProtectedRoute: 認証チェックエラー:", error);
                setIsAuthenticated(false); // エラー時も非認証
            } finally {
                setIsLoading(false);
            }
        };

        checkAuthStatus();
    }, []); 

    // ローディング中
    if (isLoading) {
        return (
            <div
                style={{
                    justifyContent: "center",
                    display: "flex",
                }}
            >
                <CircularProgress
                    size={"40vh"}
                    style={{
                        color: "#ccc",
                        top: "30vh",
                        position: "absolute",
                    }}
                />
            </div>
        );
    }

    if (isAuthenticated) {
        return <Outlet />;
    } else {
        // 認証失敗時は空のコンポーネントを返す（App.tsxで適切にリダイレクト処理される）
        console.log("ProtectedRoute: 認証失敗、空のコンポーネントを返します");
        return <></>;
    }
}

export default ProtectedRoute;
